import { Section } from "@react-email/components";
import { EmailButton } from "@/email/components/EmailButton";
import { EmailHeading } from "@/email/components/EmailHeading";
import { EmailLink } from "@/email/components/EmailLink";
import { EmailText } from "@/email/components/EmailText";
import { EmailWrapper } from "@/email/components/EmailWrapper";
import { isOurTenant } from "@/store/tenant/selectors";
import { ITenant } from "@/types/tenant";

const PasswordChangedEmail = ({
    appDomain = "https://app.1template.io",
    name = "User",
    tenant,
}: {
    appDomain: string;
    name: string;
    tenant: ITenant | null;
}) => {
    const is1TemplateTenant = isOurTenant(tenant);
    const preview = is1TemplateTenant ? "1Template " : "Your ";
    const tenantContactEmail = tenant?.contactEmail || "hello@1template.io";
    return (
        <EmailWrapper
            preview={`${preview} password reset confirmation`}
            tenant={tenant}
        >
            <Section>
                <EmailHeading>{preview} password has been reset</EmailHeading>
                <Section>
                    <EmailText>Hi {name},</EmailText>
                    <EmailText>
                        Your password has successfully been updated.
                    </EmailText>
                    <EmailText noMargin>
                        You can now login using your new password.
                    </EmailText>
                    <EmailButton href={`${appDomain}/login`}>
                        Login to your account
                    </EmailButton>
                    <EmailText>
                        If this wasn’t you, please contact us at{" "}
                        <EmailLink href={`mailto:${tenantContactEmail}`}>
                            {tenantContactEmail}
                        </EmailLink>
                        .
                    </EmailText>
                </Section>
            </Section>
        </EmailWrapper>
    );
};

export default PasswordChangedEmail;
